import { ReactNode } from "react";

import DocumentationIconButton from "components/DocumentationIconButton";
import DesktopView from "components/Mobile/DesktopView";
import MobileView from "components/Mobile/MobileView";
import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import BadgeNext from "ds/components/BadgeNext";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import useCanCreateIntegrations from "shared/Integrations/access/useCanCreateIntegrations";
import { BillingTierFeature } from "types/generated";
import { DocsUrl } from "utils/getDocsUrl";
import { AccountContext } from "views/AccountWrapper";

type IntegrationsPageLayoutProps = {
  children: ReactNode;
  onCreate?: () => void;
  title: string;
  isBeta?: boolean;
  billingTierFeature: BillingTierFeature;
  docsUrl: DocsUrl;
  docsTooltipText: string;
};

const IntegrationsPageLayout = ({
  children,
  onCreate,
  title,
  isBeta,
  billingTierFeature,
  docsUrl,
  docsTooltipText,
}: IntegrationsPageLayoutProps) => {
  const { accountName } = useTypedContext(AccountContext);
  const canCreateIntegrations = useCanCreateIntegrations(billingTierFeature);

  useTitle(`${title} · ${accountName}`);

  return (
    <>
      <ViewHeader firstLevel>
        <ViewHeaderTitle>
          <Box justify="center" align="center" gap="medium">
            <ViewHeaderTitle>{title}</ViewHeaderTitle>
            {isBeta && <BadgeNext variant="blue" text="BETA" type="strong" />}
          </Box>
        </ViewHeaderTitle>
        <MobileView>
          {canCreateIntegrations && onCreate && (
            <Button onPress={onCreate} variant="primary">
              Create integration
            </Button>
          )}
        </MobileView>

        <DesktopView>
          <ViewHeaderWrapper direction="row">
            <DocumentationIconButton href={docsUrl} tooltipText={docsTooltipText} />

            {canCreateIntegrations && onCreate && (
              <Button onPress={onCreate} variant="primary">
                Create integration
              </Button>
            )}
          </ViewHeaderWrapper>
        </DesktopView>
      </ViewHeader>
      {children}
    </>
  );
};

export default IntegrationsPageLayout;
